import React from 'react';
import {Icon} from '@iconify/react';
import {useDispatch, useSelector} from 'react-redux';
import {t} from 'i18next';
import {scrollLeftAction, scrollRightAction} from '../../../../store/actions/presentation.actions';
import {useSlideSelectable} from '../../../../hooks/useSlideSelectable';
import {currentSlideIndexSelector} from '../../../../store/selectors/presentation.selectors';
import TooltipWrapper from '../../../../ui/components/common/TooltipWrapper';

interface SlideNavigationProps {
    children: React.ReactNode;
}

function SlideNavigation({children}: SlideNavigationProps): JSX.Element {
    const dispatch = useDispatch();
    const currentSlideIndex = useSelector(currentSlideIndexSelector);
    const {isSelectable, blockedTooltipKey} = useSlideSelectable(currentSlideIndex + 1);

    return (
        <>
            <button
                type="button"
                className="c-slideNavigation"
                onClick={() => dispatch(scrollLeftAction())}
                disabled={currentSlideIndex === 0}
                data-cy="prev_slide"
            >
                <Icon icon="ph:caret-left" fontSize="2.5rem" />
            </button>
            {children}
            <div className="c-slideNavigation">
                <TooltipWrapper
                    id="nextBtnDisabledTooltip"
                    content={t(blockedTooltipKey)}
                    disable={isSelectable}
                    delayShow={300}
                    className="c-slideNavigation__tooltip"
                >
                    <button type="button" disabled={!isSelectable} onClick={() => dispatch(scrollRightAction())} data-cy="next_slide">
                        <Icon icon="ph:caret-right" fontSize="2.5rem" />
                    </button>
                </TooltipWrapper>
            </div>
        </>
    );
}

export default SlideNavigation;
